/**
 *  var enterpriseInfo = umuUtil.getEnterpriseInfo() || UTIL.getPageData('data.enterprise') || {};
    var teacherInfo = umuUtil.getTeacherInfo();
    var logoPc = util.getData('enterpriseInfo.logoPc', teacherInfo);

    scope.logoPc = logoPc || enterpriseInfo.logo;
    scope.isEnterprise = !!enterpriseInfo.enterpriseId || !!enterpriseInfo.enterprise_id || !!util.getData('enterpriseInfo.enterpriseId', teacherInfo);
 */
export default interface IEnterpriseInfo {
    enterprise_id: string;
    enterprise_name: string;
    logo?: string;
    logo_pc: string; // logoPc
    role_type: string;
    isUseEnterprise?: boolean; // 是否为 USE 企业
    isOnlyUseEnterpriseAccount?: boolean; // 是否仅为 USE 账户
    isOnlyUmuEnterpriseAccount?: boolean; // 是否仅为 UMU 账户
    isUseAndUmuEnterpriseAccount?: boolean; // 是否为 USE 和 UMU 账户
}


export enum ToolsSwitch {
    notOpen = 0, // 未开通
    open = 1, // 已开通
    onlyTools = 2, // 企业仅开通 AI Tools 功能（没有学习平台的功能）
}